import React from 'react';

interface RolePillProps {
  role: string | null;
  isYou: boolean;
}

/**
 * Compact badge rendered next to the comment author's name.
 * Three visual variants:
 *   - "You" (purple solid) — current viewer
 *   - "Trainer"/"Admin"/"Owner" (red tint, dark text) — staff
 *   - any other role (grey tint, dark text)
 *
 * Roles other than 'learner' fall through to the staff visual when not
 * explicitly recognised so future role names land on the louder variant.
 */
const STAFF_ROLES = new Set(['trainer', 'admin', 'owner', 'analyst', 'billing', 'integrator']);

export default function RolePill({ role, isYou }: RolePillProps) {
  if (isYou) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-primary-500 text-xs leading-4 font-normal whitespace-nowrap">
        You
      </span>
    );
  }
  if (!role) return null;
  const label = role.charAt(0).toUpperCase() + role.slice(1);
  const isStaff = STAFF_ROLES.has(role.toLowerCase());
  if (isStaff) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-error-500/10 text-grey-800 dark:text-text-primary text-xs leading-4 font-normal whitespace-nowrap">
        {label}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-grey-950/[0.08] dark:bg-white/10 text-grey-950 dark:text-text-primary text-xs leading-4 font-normal whitespace-nowrap">
      {label}
    </span>
  );
}
